import {
  Grid as MuiGrid,
  Typography as MuiTypography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoCard from "./InfoCard";

interface Props {
  protocolStatus?: string;
  protocolSummaryAccrual?: boolean;
}

const StudyStatusCard = ({ protocolStatus, protocolSummaryAccrual }: Props) => {
  const { t } = useTranslation();

  return (
    <InfoCard>
      <MuiGrid
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 4,
          alignItems: "flex-start",
        }}
      >
        <MuiGrid>
          <MuiTypography variant="body2" color="text.secondary" mb={0.5}>
            Study Status:
          </MuiTypography>
          <MuiTypography fontWeight={500} sx={{ fontSize: "22px" }}>
            {t("irbStatus." + protocolStatus) || "—"}
          </MuiTypography>
        </MuiGrid>

        <MuiGrid>
          <MuiTypography variant="body2" color="text.secondary" mb={0.5}>
            Accrual Type:
          </MuiTypography>
          <MuiTypography fontWeight={700} sx={{ fontSize: "14px" }}>
            {protocolSummaryAccrual ? "Summary Accrual" : "Per-Participant"}
          </MuiTypography>
        </MuiGrid>
      </MuiGrid>
    </InfoCard>
  );
};

export default StudyStatusCard;
